import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { DataViewModule } from "primeng/dataview";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { TabViewModule } from "primeng/tabview";

import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";

import { VisitorMultiStationComponent } from "./components/visitor-multistation.component";

import { MultiStationDesignComponent } from "./multi-station-design/multi-station-design.component";
import { DataService_MultiStationDesigner } from "./multi-station-design/shared/data.service";
import { MultiStationViewVisitorsComponent } from "./multi-station-view-visitors/multi-station-view-visitors.component";
import { MsVisitorSelectorComponent } from "./multi-station-view-visitors/ms-visitor-selector/ms-visitor-selector.component";
import { MsVisitorInfoComponent } from "./multi-station-view-visitors/ms-visitor-info/ms-visitor-info.component";
import { MsVisitorHistoryComponent } from "./multi-station-view-visitors/ms-visitor-history/ms-visitor-history.component";
import { MsVisitorOffenderLookupComponent } from "./multi-station-view-visitors/ms-visitor-offender-lookup/ms-visitor-offender-lookup.component";
import { MsVisitorOffenderLookupHistoryComponent } from "./multi-station-view-visitors/ms-visitor-offender-lookup-history/ms-visitor-offender-lookup-history.component";
import { DataService_MultiStationViewVisitors } from "./multi-station-view-visitors/shared/data.service";
import { MsDemographicLocationTableComponent } from "./multi-station-view-visitors/ms-visitor-info/ms-demographic-location-table/ms-demographic-location-table.component";
import { MsDemographicVisiteeTableComponent } from "./multi-station-view-visitors/ms-visitor-info/ms-demographic-visitee-table/ms-demographic-visitee-table.component";
import { MsHistoryMainTableComponent } from "./multi-station-view-visitors/ms-visitor-history/ms-history-main-table/ms-history-main-table.component";
import { MsHistoryDetailsTableComponent } from "./multi-station-view-visitors/ms-visitor-history/ms-history-details-table/ms-history-details-table.component";
import { MultiStationVisiteeMaintenanceComponent } from "./multi-station-visitee-maintenance/multi-station-visitee-maintenance.component";
import { MsVisiteeManualModeComponent } from "./multi-station-visitee-maintenance/ms-visitee-manual-mode/ms-visitee-manual-mode.component";
import { MsVisiteeBatchModeComponent } from "./multi-station-visitee-maintenance/ms-visitee-batch-mode/ms-visitee-batch-mode.component";
import { MsVisiteeStaffTableComponent } from "./multi-station-visitee-maintenance/ms-visitee-manual-mode/ms-visitee-staff-table/ms-visitee-staff-table.component";
import { DataService_MultiStationVisiteeMaintenance } from "./multi-station-visitee-maintenance/shared/data.service";
import { VisiteeBatchTableComponent } from "./multi-station-visitee-maintenance/ms-visitee-batch-mode/visitee-batch-table/visitee-batch-table.component";
import { MsVisiteeBatchImportComponent } from "./multi-station-visitee-maintenance/ms-visitee-batch-mode/ms-visitee-batch-import/ms-visitee-batch-import.component";
import { MsVisiteeBatchDownloadComponent } from "./multi-station-visitee-maintenance/ms-visitee-batch-mode/ms-visitee-batch-download/ms-visitee-batch-download.component";
import { MsVisiteeBatchExportComponent } from "./multi-station-visitee-maintenance/ms-visitee-batch-mode/ms-visitee-batch-export/ms-visitee-batch-export.component";
import { MultiStationCurrentVisitorsComponent } from "./multi-station-current-visitors/multi-station-current-visitors.component";
import { MultiStationBlockedVisitorsComponent } from "./multi-station-blocked-visitors/multi-station-blocked-visitors.component";
import { MsVisitorParentChildComponent } from "./multi-station-view-visitors/ms-visitor-parent-child/ms-visitor-parent-child.component";
import { VisitorAddParentChildComponent } from "./multi-station-view-visitors/ms-visitor-parent-child/visitor-add-parent-child/visitor-add-parent-child.component";
import { VisitorAddParentChildTableComponent } from "./multi-station-view-visitors/ms-visitor-parent-child/visitor-add-parent-child/visitor-add-parent-child-table/visitor-add-parent-child-table.component";
import { MultiStationViewLogsComponent } from "./multi-station-view-logs/multi-station-view-logs.component";
import { MultiStationViewLogVisitorComponent } from "./multi-station-view-logs/multi-station-view-log-visitor/multi-station-view-log-visitor.component";
import { DataService_MultiStationCurrentVisitors } from "./multi-station-current-visitors/shared/data.service";
import { DataService_MultiStationBlockedVisitors } from "./multi-station-blocked-visitors/shared/data.service";
import { MultiStationPreRegistrationComponent } from "./multi-station-pre-registration/multi-station-pre-registration.component";
import { MsBlockedVisitorImportComponent } from "./multi-station-blocked-visitors/ms-blocked-visitor-import/ms-blocked-visitor-import.component";
import { MsVisitorAddComponent } from "./shared/ms-visitor-add/ms-visitor-add.component";
import { MsVisitorEditComponent } from "./shared/ms-visitor-edit/ms-visitor-edit.component";
import { DataService_MultiStationModifyVisitors } from "./shared/shared/data.service";
import { MsBlockedVisitorExportComponent } from "./multi-station-blocked-visitors/ms-blocked-visitor-export/ms-blocked-visitor-export.component";
import { MultiStationVerifyVisitorComponent } from "./multi-station-verify-visitor/multi-station-verify-visitor.component";
import { DataService_MultiStationVerifyVisitor } from "./multi-station-verify-visitor/shared/data.service";
import { MsVisitorBlockedExceptionsComponent } from "./multi-station-blocked-visitors/ms-visitor-blocked-exceptions/ms-visitor-blocked-exceptions.component";
import { MultiStationVisitorTypeMaintenanceComponent } from "./multi-station-visitor-type-maintenance/multi-station-visitor-type-maintenance.component";
import { DataService_MultiStationVisitorTypeMaintenance } from "./multi-station-visitor-type-maintenance/shared/data.service";
import { MsAddVisitorTypeComponent } from "./multi-station-visitor-type-maintenance/ms-add-visitor-type/ms-add-visitor-type.component";
import { MsEditVisitorTypeComponent } from "./multi-station-visitor-type-maintenance/ms-edit-visitor-type/ms-edit-visitor-type.component";
import { MultiStationLocationMaintenanceComponent } from "./multi-station-location-maintenance/multi-station-location-maintenance.component";
import { MsLocationAddComponent } from "./multi-station-location-maintenance/ms-location-add/ms-location-add.component";
import { MsLocationEditComponent } from "./multi-station-location-maintenance/ms-location-edit/ms-location-edit.component";
import { DataService_LocationMaintenance } from "./multi-station-location-maintenance/shared/data.service";
import { MsVisitorAliasesComponent } from "./multi-station-view-visitors/ms-visitor-aliases/ms-visitor-aliases.component";
import { MsAddAliasComponent } from "./multi-station-view-visitors/ms-visitor-aliases/ms-add-alias/ms-add-alias.component";
import { MsPrintPassInstructionsComponent } from "./multi-station-view-visitors/ms-visitor-offender-lookup/ms-print-pass-instructions/ms-print-pass-instructions.component";
import { MultiStationSettingsComponent } from "./multi-station-settings/multi-station-settings.component";
import { DataService_MultiStationSettings } from "./multi-station-settings/shared/data.service";
import { MsOffenderVerifiedTableComponent } from "./multi-station-view-visitors/ms-visitor-offender-lookup/ms-offender-verified-table/ms-offender-verified-table.component";
import { MultiStationReasonMaintenanceComponent } from "./multi-station-reason-maintenance/multi-station-reason-maintenance.component";
import { DataService_ReasonMaintenance } from "./multi-station-reason-maintenance/shared/data.service";
import { MsAddVisitorReasonComponent } from "./multi-station-reason-maintenance/ms-add-visitor-reason/ms-add-visitor-reason.component";
import { MsEditVisitorReasonComponent } from "./multi-station-reason-maintenance/ms-edit-visitor-reason/ms-edit-visitor-reason.component";
import { MultiStationNotificationMaintenanceComponent } from "./multi-station-notification-maintenance/multi-station-notification-maintenance.component";
import { MsNotificationByRoleComponent } from "./multi-station-notification-maintenance/ms-notification-by-role/ms-notification-by-role.component";
import { MsNotificationByEmailComponent } from "./multi-station-notification-maintenance/ms-notification-by-email/ms-notification-by-email.component";
import { DataService_MultiStationNotification } from "./multi-station-notification-maintenance/shared/data.service";
import { MsNotificationAddComponent } from "./multi-station-notification-maintenance/shared/ms-notification-add/ms-notification-add.component";
import { MsNotificationEditComponent } from "./multi-station-notification-maintenance/shared/ms-notification-edit/ms-notification-edit.component";
import { MsNotifyFacilitySelectComponent } from "./multi-station-notification-maintenance/shared/ms-notify-facility-select/ms-notify-facility-select.component";
import { FacilityOrDistrictPopupComponent } from "./multi-station-notification-maintenance/shared/facility-or-district-popup/facility-or-district-popup.component";
import { MsBlockedPrintConfirmComponent } from "./multi-station-blocked-visitors/ms-blocked-print-confirm/ms-blocked-print-confirm.component";
import { MultiStationManualLookupSuComponent } from "./multi-station-manual-lookup-su/multi-station-manual-lookup-su.component";
import { DataService_MultiStationManualLookupV2 } from "./multi-station-manual-lookup-su/shared/data.service";
import { MultistationDistrictSettingsComponent } from "./multi-station-settings/multistation-district-settings/multistation-district-settings.component";
import { MultistationFacilitySettingsComponent } from "./multi-station-settings/multistation-facility-settings/multistation-facility-settings.component";
import { MultistationStationSettingsComponent } from "./multi-station-settings/multistation-station-settings/multistation-station-settings.component";

@NgModule({
	declarations: [
		VisitorMultiStationComponent,
		MultiStationDesignComponent,
		MultiStationViewVisitorsComponent,
		MsVisitorSelectorComponent,
		MsVisitorInfoComponent,
		MsVisitorHistoryComponent,
		MsVisitorOffenderLookupComponent,
		MsVisitorOffenderLookupHistoryComponent,
		MsDemographicLocationTableComponent,
		MsDemographicVisiteeTableComponent,
		MsHistoryMainTableComponent,
		MsHistoryDetailsTableComponent,
		MultiStationVisiteeMaintenanceComponent,
		MsVisiteeManualModeComponent,
		MsVisiteeBatchModeComponent,
		MsVisiteeStaffTableComponent,
		VisiteeBatchTableComponent,
		MsVisiteeBatchImportComponent,
		MsVisiteeBatchDownloadComponent,
		MsVisiteeBatchExportComponent,
		MultiStationCurrentVisitorsComponent,
		MultiStationBlockedVisitorsComponent,
		MsVisitorParentChildComponent,
		VisitorAddParentChildComponent,
		VisitorAddParentChildTableComponent,
		MultiStationViewLogsComponent,
		MultiStationViewLogVisitorComponent,
		MultiStationPreRegistrationComponent,
		MsBlockedVisitorImportComponent,
		MsVisitorAddComponent,
		MsVisitorEditComponent,
		MsBlockedVisitorExportComponent,
		MultiStationVerifyVisitorComponent,
		MsVisitorBlockedExceptionsComponent,
		MultiStationVisitorTypeMaintenanceComponent,
		MsAddVisitorTypeComponent,
		MsEditVisitorTypeComponent,
		MultiStationLocationMaintenanceComponent,
		MsLocationAddComponent,
		MsLocationEditComponent,
		MsVisitorAliasesComponent,
		MsAddAliasComponent,
		MsPrintPassInstructionsComponent,
		MultiStationSettingsComponent,
		MsOffenderVerifiedTableComponent,
		MultiStationReasonMaintenanceComponent,
		MsAddVisitorReasonComponent,
		MsEditVisitorReasonComponent,
		MultiStationNotificationMaintenanceComponent,
		MsNotificationByRoleComponent,
		MsNotificationByEmailComponent,
		MsNotificationAddComponent,
		MsNotificationEditComponent,
		MsNotifyFacilitySelectComponent,
		FacilityOrDistrictPopupComponent,
		MsBlockedPrintConfirmComponent,
		MultiStationManualLookupSuComponent,
		MultistationDistrictSettingsComponent,
		MultistationFacilitySettingsComponent,
		MultistationStationSettingsComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		MatSlideToggleModule,
		RouterModule,
		PersonSelectorModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		SchoolselectorModule,
		DataViewModule,
		TabViewModule,
	],
	providers: [
		ConfirmationService,
		DataService_MultiStationDesigner,
		DataService_MultiStationViewVisitors,
		DataService_MultiStationVisiteeMaintenance,
		DataService_MultiStationCurrentVisitors,
		DataService_MultiStationBlockedVisitors,
		DataService_MultiStationModifyVisitors,
		DataService_MultiStationVerifyVisitor,
		DataService_MultiStationVisitorTypeMaintenance,
		DataService_LocationMaintenance,
		DataService_MultiStationSettings,
		DataService_ReasonMaintenance,
		DataService_MultiStationNotification,
		DataService_MultiStationManualLookupV2,
	],
})
export class VisitorMultiStationModule {}
